import * as React from 'react';

import {
  CONTACT,
  FOOTER_LINK_SECTIONS,
  HEADER_LINK_SECTIONS,
  OTHER_SITE_LINKS,
  SITE_LOCALE,
} from 'app-constants';

import { Footer } from 'stile-shared/src/components/2024/common/Footer';
import { Header } from 'stile-shared/src/components/2024/common/Header';

import STS4Badge from '../../../../stile-shared/assets/images/privacy/safer_technologies_for_schools_badge.png';

export type PageLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export function PageLayout({ className, children }: PageLayoutProps) {
  return (
    <div className={`twentyTwentyFour ${className}`}>
      <Header headerLinks={HEADER_LINK_SECTIONS} />
      <div className="main-content">{children}</div>
      <Footer
        locale={SITE_LOCALE}
        phone={CONTACT.au.phone}
        linkSections={FOOTER_LINK_SECTIONS}
        otherLinks={OTHER_SITE_LINKS}
        badges={[
          {
            text: 'Stile has been assessed by Safer Technologies for Schools',
            url: 'https://st4s.edu.au/',
            src: STS4Badge,
            width: 80,
          },
        ]}
        statement={CONTACT.au.address.descriptive}
      />
    </div>
  );
}
